import React, { Component } from 'react';
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import PropTypes from 'prop-types';
import { browserHistory, Link } from 'react-router';
import { userLogin } from 'store/user';
import Modal from 'components/Modal';
import InputValidation from 'components/InputValidation';
import { spin, stop } from 'store/spinner';
import LogoImage from 'assets/Basiligo-Logo.png';
import AndroidImage from 'assets/andriod-app.png';
import AppleImage from 'assets/apple-app.png';
import LogoImageIcon from 'assets/b-logo-icon.png';
import DietPlanIcon from 'assets/diat-plan.gif';
class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      smscode: '',
      showsms: false,
      errorModalMessage: '',
      showPassword: false,
      errors: {},
      xyz: false
    };
  }

  socketLogin = ({ type, data, message, banned, smscode }) => {

    if (this.SignInRef) {
      if (type === 'smsOk') {
        this.setState({
          showsms: true,
          errorModalMessage: message,
        });
      } else if (type === 'setOk') {
        this.props.login(data);
        browserHistory.push('/');
      } else if (type === 'smsErr') {
        this.setState({
          errorModalMessage: message,
        });
      } else if (['setErr', 'facebookErr', 'googleErr'].indexOf(type) > -1) {
        const { errors } = data;
        const { email, password } = errors;
        if(email == undefined && password != undefined){
           message = password[0];
        }
        const bannedMessage = 'Dear Customer,\n' +
          'Thank you for your interest. We are really sorry but it seems that your profile cannot be activated. ' +
          'Please contact our team on team@basiligo.ae or 02-553-0049 for further clarifications.\n' +
          'Regards,\n' +
          'Basiligo Team';
        this.setState({ errorModalMessage: banned ? bannedMessage : message });
      }
    }
  };

  componentWillMount() {
    this.props.socket.on('login', this.socketLogin);
  }

  componentWillUnmount() {
    this.props.socket.removeListener('login', this.socketLogin);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ xyz: true }), 10);
  }

  submit(e, browserId) {
    e.preventDefault();
    const { email, password, smscode } = this.state;
	// console.log('Login Trigger');
  // alert("Our website is temporarily down for maintenance to improve your experience");
  // return false;
    this.props.socket.emit('login', { type: 'set', data: { email, password, browserId, app: 'customer', smscode: smscode } });
  }

  submitFacebook(response, browserId) {
    if ('id' in response) {
      this.props.socket.emit('login', { type: 'facebook', data: { ...response, browserId }, app: 'customer' });
    }
  } 

  submitGoogle(response, browserId) {
    this.props.socket.emit('login', { type: 'google', data: { ...response, browserId }, app: 'customer' });
  }

  render() {
    const onChange = (name, value) => this.setState({ [name]: value });
    const { errors, errorModalMessage, email, password, xyz, showsms, smscode } = this.state;
    const { settings, browserId,stop } = this.props;
    // const facebookAppId = settings.getValue('FACEBOOK_APP_ID');
    // const googleAppId = settings.getValue('GOOGLE_APP_ID');
    const facebookAppId = '';
    const googleAppId = '';
	//console.log(browserId);
    return (
      <div ref={el => (this.SignInRef = el)} className='full-width'>
        <div className='sign-container'>
        <div className='sign-b-left'>           
            {/* <div className='logo-icon'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImageIcon} alt='Basiligo' /></Link></div> */}
            <div className='sign-up-form'>
              <div className='logo mb-4'> <img src={LogoImage} alt='Basiligo' className='img-logo' /></div> 
              <div className='search-title mt-1'>
                <h1>Clean Eating Meal Plans</h1>
                <h3>Login to access & change the menu options</h3>
              {/* <span className='colorTitle'>Sign In</span> */}
              {/* <Link to='/sign-up' className='colorTitle ml-3'>Sign Up</Link> */}
              </div>
              <form className='form' onSubmit={e => this.submit(e, browserId)}>
                <div className='sign-form-container'>
                {!showsms && <div className='sign-up-input mt-4'><label class="textLeft">Email address</label>
                  <InputValidation
                    value={email}
                    name='email'
                    onChange={onChange}
                    placeholder='Enter your email address'
                    errors={errors}
                    inputSelfClassName='standart-input b-rounded-blue'
                  />
                </div>}
                {!showsms && <div className='sign-up-input mt-4'><label class="textLeft">Password</label>
                  <InputValidation
                    type='password'
                    name='password'
                    value={password}
                    onChange={onChange}
                    placeholder='Enter your password'
                    errors={errors}
                    inputSelfClassName='standart-input b-rounded-blue'
                  />
                </div>}
                {showsms && <div className='sign-up-input mt-4'>
                  <InputValidation
                    type='smscode'
                    name='smscode'
                    value={smscode}
                    onChange={onChange}
                    placeholder='Sms Code'
                    errors={errors}
                    inputSelfClassName='standart-input b-rounded-blue'
                  />
                </div>}
                <div className='search-title login-text mt-3'>
                <p className='line-height-xsnormal login-text mb-0'>
                  By signing in or signing up, I agree to Basiligo &nbsp;
                  <Link to='/terms' >Terms & Conditions</Link>, <Link to='/refunds' >Refund & Cancellation policy</Link>, <Link to='/privacy-policy' >Privacy Policy</Link>,
                  I confirm that I am 18 years of age or older, and consent to receiving email communication.
                </p>
                </div>
                <div className='login-text mt-3  text-right'>
                  <span><Link to='/restore'>Forgot password?</Link></span>
                </div></div>
                <div className='sign-up-input mt-4 sign-up-button d-flex align-items-center justify-content-around'>
                  <input type='submit' value='Login' className='form-button letter-sm w-100' />
                </div>
              </form>
              {/*<div className='search-title login-text mt-3'>
                <span className='colorTitle letter-sm'>Or</span>
        </div>*/}
              {googleAppId && <GoogleLogin
                clientId={googleAppId}
                onSuccess={response => this.submitGoogle(response, browserId)}
                buttonText='Sign in with Google'
                className='sign-up-input mt-3 sign-up-button-google d-flex align-items-center justify-content-around'
                onFailure={data => console.log(data)}
              />}
              {facebookAppId && <FacebookLogin
                appId={facebookAppId}
                size='small'
                callback={response => this.submitFacebook(response, browserId)}
                fields='name,email,picture,first_name,last_name'
                textButton='Sign in with Facebook'
                cssClass='sign-up-input mt-3 mb-2 sign-up-button-facebook d-flex align-items-center justify-content-around'
              />}
              {/* <div className='mt-4 mr-1 text-center sign-up-bottom'>
            <span className='mt-1 mr-1'>Don’t have an Account? </span>
              <span className='login-text'><Link to='/sign-up'>Create your Account</Link></span>
              </div> */}
            </div>
            {errorModalMessage &&
              <Modal
                close={() => this.setState({ errorModalMessage: '' })}
                message={errorModalMessage}
              />
            }
        </div>
        <div className={`sign-b-right`}>
            <div className='sign-b-right-details'><h2>Plan First, Eat Smart</h2>
            <h6>Explore your menu, select your dishes, and discover new healthy favorites —<br/><strong>all before you subcribe.</strong></h6>
            <ul className='login-list'>
              <li>Preview every meal</li>
              <li>Personalize your plan</li>
              <li>Full ingredient transparency</li>
            </ul>
            <div className='app-store-gpay'>
                <Link to='https://apps.apple.com/bg/app/basiligo-meal-plan/id6496685190' ><img className='img-play' src={AppleImage} alt='Basiligo Apple Store' /></Link>
              <Link to='https://play.google.com/store/apps/details?id=com.basiligo.basiligomobileapp' ><img className='img-app' src={AndroidImage} alt='Google Play Store' /></Link>
            </div>
            <h6 className='applink-head'>Download the Basiligo App to Get Started</h6>
            </div>
      </div>
      </div>
      </div>
    );
  }
}

SignIn.propTypes = {
  socket: PropTypes.object.isRequired,
  settings: PropTypes.object,
  browserId: PropTypes.string,
  login: PropTypes.func.isRequired
};

const props = state => ({
  browserId: state.user.browserId,
  language: state.user.language,
  settings: state.settings
});

const actions = dispatch => ({
  login: user => dispatch(userLogin(user)),
  spin: () => dispatch(spin()),
  stop: () => dispatch(stop()),
});

export default socketConnect(connect(props, actions)(SignIn));
